import { SnackbarContent } from '@patrianna/core-components'
import cx from 'classnames'
import { useEffect } from 'react'

import { useReturnToCashier } from 'src/hooks/useReturnToCashier'
import { closeSnackbar } from 'src/store/modules/snackbar/actions'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { getSnackbarMessageAlignSelector, getSnackbarVariantSelector } from 'store/modules/snackbar/selectors'

import Message from './Message'
import classes from './styles.module.scss'

export interface SnackbarProps {
  className?: string
  message?: string
  offerCode: string
}

function RepeatPaymentSnackbar(props: SnackbarProps) {
  const { message, offerCode, ...other } = props
  const handleRepeatPayment = useReturnToCashier()

  const variant = useAppSelector(getSnackbarVariantSelector)
  const messageAlign = useAppSelector(getSnackbarMessageAlignSelector)

  const dispatch = useAppDispatch()

  const onClose = () => dispatch(closeSnackbar())

  useEffect(() => {
    handleRepeatPayment?.(offerCode)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleRepeatPayment])

  return (
    <SnackbarContent
      className={cx(classes[messageAlign], classes[variant])}
      message={<Message message={message} onClose={onClose} />}
      {...other}
    />
  )
}

export default RepeatPaymentSnackbar
